import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store/store'
import { resetGame } from '../../../store/appSlice'
import styles from './gameEnd.module.scss'

//TODO move this logic to a hook

interface GameEndProps {
  startNewGame: () => void
}
const GameEnd: React.FC<GameEndProps> = (props) => {
  const dispatch = useDispatch()
  const totalPoints = useSelector((state: RootState) => state.totalPoints)

  const handleNewGame = () => {
    dispatch(resetGame())
    props.startNewGame()
  }

  //TODO add submit to leaderboard functionality
  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <h2 className={styles.title}>Nice game!</h2>
        <p className={styles.points}>
          Total Points: <span>{totalPoints}</span>
        </p>
        <div className={styles.buttons}>
          <button className="buttonBlue">
            <a
              className={styles.support}
              href="https://www.buymeacoffee.com/languageguessr"
              target="_blank"
              rel="noreferrer"
            >
              <p>Support this project</p>
            </a>
          </button>
          <button className={styles.newGame} onClick={handleNewGame}>
            New Game
          </button>
        </div>
      </div>
    </div>
  )
}

export default GameEnd
